/* eslint-disable */
require('./active-sub')
require('./add-icon')
require('./add')
require('./approve')
require('./arrow-down-thin')
require('./arrow-down')
require('./attachment')
require('./avatar')
require('./booking')
require('./calendar')
require('./camera-icon')
require('./camera-two')
require('./camera')
require('./cancel')
require('./check-circle')
require('./Combined-Shape')
require('./delete')
require('./description')
require('./design-element-three')
require('./design-element-two')
require('./design-element')
require('./document')
require('./download')
require('./drop-down')
require('./earnings_icon')
require('./eye-off-icon')
require('./identification')
require('./info-icon')
require('./invoice')
require('./listing_icon')
require('./listing')
require('./maintenance')
require('./members')
require('./menu')
require('./monthly-income')
require('./overview')
require('./payment')
require('./profile')
require('./publish__icon')
require('./remove')
require('./roomPlaceholder')
require('./rules-icon')
require('./search')
require('./selfie')
require('./settings')
require('./settlement')
require('./spinner')
require('./step-check')
require('./subscription')
require('./table-menu')
require('./team-mem-group')
require('./tick')
require('./trash-icon')
require('./user')
require('./view')
require('./warning-icon')



// WEBPACK FOOTER //
// ./src/assets/icons/index.js